import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { setTraceHeaders } from './setTraceHeaders';

interface RegisterRequest {
    username: string;
}

interface OTPRequest {
    email: string;
}

interface LoginRequest {
    email: string;
    otp: string;
    session: string;
}

interface RefreshTokenRequest {
    refreshToken: string;
}

interface LogoutRequest {
    accessToken: string;
    refreshToken: string;
}

export const api = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window._env_.REACT_APP_API_BASE_URL,
        prepareHeaders: (headers) => {
            setTraceHeaders(headers);

            return headers;
        },
    }),
    endpoints: (builder) => ({
        register: builder.mutation<any, RegisterRequest>({
            query: ({ username }) => ({
                url: 'auth/create-user',
                method: 'POST',
                body: {
                    username,
                    userAttributes: [
                        { name: 'email', value: username },
                        { name: 'custom:isD2CUser', value: 'true' },
                    ],
                },
            }),
        }),
        requestOTP: builder.mutation<any, OTPRequest>({
            query: ({ email }) => ({
                url: 'api/auth/token/otp',
                method: 'POST',
                body: {
                    email,
                },
            }),
        }),
        confirmOTP: builder.mutation<any, LoginRequest>({
            query: ({ email, otp, session }) => ({
                url: 'api/auth/token/otp/confirm',
                method: 'POST',
                body: {
                    email,
                    otp,
                    session,
                },
            }),
        }),
        refreshTokens: builder.mutation<any, RefreshTokenRequest>({
            query: ({ refreshToken }) => ({
                url: 'api/auth/refresh-token',
                method: 'POST',
                body: {
                    refreshToken,
                },
            }),
        }),
        logout: builder.mutation<any, LogoutRequest>({
            query: ({ accessToken, refreshToken }) => ({
                url: 'api/auth/logout',
                method: 'POST',
                body: {
                    accessToken,
                    refreshToken,
                },
            }),
        }),
    }),
});
